import request from './request'
import type { ProjectTimelineResponse } from '@/types/projectTimeline'

export const projectTimelineApi = {
  getByProjectId: (projectId: number) => request.get<ProjectTimelineResponse>(`/projects/${projectId}/timeline`),
}